// extracted by mini-css-extract-plugin
module.exports = {"form":"CreatePage_form__Th--R"};